import React from "react";
import { Route, Routes } from "react-router-dom";
import SignIn from "../pages/SignIn";
import SignUp from "../pages/SignUp";
import Home from "../pages/Home";
import LoggedOut from "../pages/LoggedOut";

function UnAuthenticatedRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/logged-out" element={<LoggedOut />} />
      <Route path="/*" element={<SignIn />}></Route>
    </Routes>
  );
}

export default UnAuthenticatedRoutes;
